<app-fleet-page-header
  (clearFilter)="model.resetFilter()"
  (clearSearch)="model.setSearch('')"
  (dateRangeChanged)="model.setDateRange($event, true)"
  (export)="model.exportReport($event)"
  (filterChanged)="model.setFilter($event, true)"
  (rememberFiltersChanged)="model.setRememberFilters($event)"
  (searchChanged)="model.setSearch($event)"
  (sortChanged)="model.setOrder($event, true)"
  [adaptiveMenuOptions]="adaptiveMenuOptions$ | async"
  [columns]="model.state.columns$ | async"
  [dateRange]="model.state.dateRange$ | async"
  [defaultSortOrder]="model.state.defaultSortOrder$ | async"
  [filterOptions]="model.state.filterOptions$ | async"
  [reserveFilterButton]="true"
  [filterValue]="model.state.filter$ | async"
  [rememberFilterValues]="model.state.rememberFilters$ | async"
  [headerTextSize]="headerTextSize()"
  [mobileSingleRowControls]="true"
  [search]="model.state.search$ | async"
  [showDatePickerTime]="true"
  [showDatePicker]="true"
  [showExport]="true"
  [showSearch]="true"
  [sortOrder]="model.state.gridSortOrder$ | async"
  [templates]="{ description: headerDescriptionTmpl() }"
  [titleText]="(deviceService.isMobile$ | async) ? 'fleet-settings.title' : 'audit-log.header'"
  [descriptionText]="'audit-log.logs-stored' | translate: { count: 180 }"
></app-fleet-page-header>

<ng-content></ng-content>

<main class="grid-wrapper flex--col scroll-wrapper scrollbar-gray">
  <app-audit-logs-grid></app-audit-logs-grid>
</main>
